/*portugieser */
export function registerKendoTheme () {
    kendo.dataviz.ui.registerTheme('customInsa', 
    {   
        "chart": {
            "title": {
                "color": "#686868"
            },
            "legend": {
                "labels": {
                    "color": "#686868"
                }
            },
            "chartArea": {
                "background": "#ffffff"
            },
            "seriesDefaults": {
                "labels": {
                    "color": "#686868"
                },
           "pie": {
             "overlay": {
                 "gradient": "none"
             }
         },
         
         "donut": {
             "overlay": {
                 "gradient": "none"
             }
         },
         "column": {
             "overlay": {
                 "gradient": "none"
             }
         }
            },
            "axisDefaults": {
                "line": {
                    "color": "#9e9e9e"
                },
                "labels": {
                    "color": "#686868"
                },
                "minorGridLines": {
                    "color": "#e7e7e7"
                },
                "majorGridLines": {
                    "color": "#dadada"
                },
                "title": {
                    "color": "#686868"
                }
            },
            "seriesColors": [
                "#002143",
                "#1D3F64",
                "#4B6487",
                "#8091AD",
                "#BCC6D7",
                "#B68C65",
                "#D0B396",
                "#EADCCE",
                "#B48A72",
                "#E0BAA3"
            ]
        },
        "gauge": {
            "pointer": {
                "color": "#454E7E"
            },
            "scale": {
                "rangePlaceholderColor": "#e7e7e7",
                "labels": {
                    "color": "#686868"
                },
                "minorTicks": {
                    "color": "#aaaaaa"
                },
                "majorTicks": {
                    "color": "#888888"
                },
                "line": {
                    "color": "#9e9e9e"
                }
            }
        }
    });    
}



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Kestrel/insa-kendo-css/kendo.custom.dataviz.ts